export default __webpack_public_path__ + "static/media/branding-mediumitalic-webfont.b3f7be57.woff";